import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const DownloadIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M8.528 4.021a6 6 0 0 1 6.224 4.265A1 1 0 0 0 15.71 9h1.79a3.5 3.5 0 0 1 1.945 6.41 1 1 0 0 0 1.11 1.663A5.5 5.5 0 0 0 17.5 7h-1.082a8.001 8.001 0 1 0-13.133 8.598 1 1 0 1 0 1.43-1.399A6 6 0 0 1 8.528 4.021Z" />
      <path d="M8.707 16.293a1 1 0 0 0-1.414 1.414l3.997 3.997A.993.993 0 0 0 12 22a.996.996 0 0 0 .71-.296l3.997-3.997a1 1 0 0 0-1.414-1.414L13 18.586V12a1 1 0 1 0-2 0v6.586l-2.293-2.293Z" />
    </Icon>
  )
);
export default DownloadIcon;
